export const FareCalculator = (distance, time, rateDetails, instructionData, decimal) => {  
    const numDec = (typeof decimal === 'number' && !isNaN(decimal)) ? decimal : 2;
    const dist = parseFloat(distance) || 0;
    const t = parseFloat(time) || 0;
    const rates = rateDetails || {};

    const ratePerUnit = parseFloat(rates.rate_per_unit_distance) || 0;
    const ratePerHour = parseFloat(rates.rate_per_hour) || 0;
    const baseFare = parseFloat(rates.base_fare) || 0;
    const minFare = parseFloat(rates.min_fare) || 0;
    const convFeeVal = parseFloat(rates.convenience_fees) || 0;

    let baseCalculated = (ratePerUnit * dist) + (ratePerHour * (t / 3600));
    if (baseFare > 0) {
        baseCalculated += baseFare;
    }
    if (instructionData && instructionData.parcelTypeSelected && instructionData.parcelTypeSelected.amount) {
        baseCalculated += (parseFloat(instructionData.parcelTypeSelected.amount) || 0);
    }
    if (instructionData && instructionData.optionSelected && instructionData.optionSelected.amount) {
        baseCalculated += (parseFloat(instructionData.optionSelected.amount) || 0);
    }

    let total = baseCalculated > minFare ? baseCalculated : minFare;
    if (isNaN(total) || total < 0) total = 0;

    let convenienceFee = 0;
    if (rates.convenience_fee_type && rates.convenience_fee_type === 'flat') {
        convenienceFee = convFeeVal;
    } else {
        convenienceFee = (total * convFeeVal / 100);
    }
    if (isNaN(convenienceFee) || convenienceFee < 0) convenienceFee = 0;

    let grand = total + convenienceFee;
    if (isNaN(grand) || grand < 0) grand = 0;

    // Round UP (Ceil) to the next ₦100 (e.g., ₦2,459.09 -> ₦2,500)
    if (grand > 0) {
        grand = Math.ceil(grand / 100) * 100;
        total = grand - convenienceFee;
        if (total < 0) total = 0;
    }

    const safeToFixed = (val) => {
        const num = parseFloat(val);
        return (!isNaN(num) && typeof num.toFixed === 'function') ? parseFloat(num.toFixed(numDec)) : 0;
    };

    return {
        totalCost: safeToFixed(total),
        grandTotal: safeToFixed(grand),
        convenience_fees: safeToFixed(convenienceFee)
    };
};
